<template>
    <transition name="modal custom-modal">
        <div class="modal-mask modal-lg">
            <div class="modal-wrapper">
                <div class="modal-container">
                    <div class="modal-header">
                        <button type="button" class="close" @click="$emit('close')">
                            <span aria-hidden="true">×</span><span class="sr-only">Close</span>
                        </button>
                        <h3 style="width: initial;"><i class="fa fa-lg fa-address-card"></i> {{ contact.first_name }} {{ contact.last_name }} <small>{{ contact.id }}</small></h3>
                    </div>
                    <div class="modal-body pre-scrollable" v-bind:style="{'max-height': bodyHeight + 'px'}">
                        <div class="lead-detail">
                          <div class="panel-body">
                            <div class="col-xs-12 bg-dark lead-data">
                              <h4>Contact Information ({{ contact.timestamp | formatTimestamp }})</h4>
                              <ul class="contact-info">
                                <li v-if="contact.email"><i class="fa fa-lg fa-at"></i> <b>{{ contact.email }}</b></li>
                                <li v-if="contact.phone"><i class="fa fa-lg fa-phone"></i> <b>{{ contact.phone }}</b></li>
                                <li v-if="contact.address"><i class="fa fa-lg fa-map-marker"></i> <b>{{ contact.address }}</b></li>
                              </ul>
                            </div>
                            
                            <div class="col-xs-12 bg-dark lead-data">
                              <h4>Activity</h4>
                              <table class="table">
                                <thead>
                                  <tr>
                                    <th>Timestamp</th>
                                    <th>Event Type</th>
                                    <th>Event ID</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  <tr v-for="a in contact.activity">
                                    <td>{{ a.timestamp | formatTimestamp }}</td>
                                    <td>{{ a.type }}</td>
                                    <td>{{ a.object_id }}</td>
                                  </tr>

                                </tbody>
                              </table>
                            </div>
                            
                            <div v-if="Object.keys(contact.meta).length" class="col-xs-12 bg-dark lead-data">
                              <h4>Metadata</h4>
                              <div class="col-xs-12 fields-list-wrapper">
                                <table class="table">
                                  <thead>
                                    <tr>
                                      <th>Field</th><th>Value</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    <tr v-for="v, k in contact.meta"><td>{{ k }}</td><td><b>{{ v }}</b></td></tr>
                                  </tbody>
                                </table>
                              </div>
                            </div>
                          </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </transition>
</template>


<script>

export default {
  name: 'ContactDataModal',
  props: {
    contactData: {
      type: Object
    }
  },
  data: function () {
    return {
      scoring: false,
      contact: this.contactData
    };
  },
  computed: {
    bodyHeight () {
    return $(window).height() - 200;
    }
  },

  methods: {
    formatDate(d) {
      return moment(d).format("MM/DD/YYYY HH:mm:ss");
    }
  }
}
</script>
<style>
  .panel-body div.lead-data + div {
  margin-top: 30px;
  }
  
 .modal-header h3 {
  text-transform: unset!important;
  }

  .lead-detail .panel-body h4 button {
  right: 20px;
  top: 10px;
  position: absolute;
  }
  
  .lead-detail .panel-body > div {
  padding: 10px 20px;
  }

  .lead-detail .panel-body > div.fields-list-wrapper {
  padding: 0px;
  }
  
  .lead-detail h4 {
  padding-bottom: 10px;
  }
  
  .bg-dark {
  background-color: #f7f7f7;
  border-radius: 4px 4px;
  }
  ul.contact-info li i {
  color: #aaa;
  }
  ul.contact-info > li:not(:first-child)::before {
  content: "";
  display: inline-block;
  vertical-align: middle;
  border: 1px solid #dadada;
  width: .75em;
  margin-left: 20px;
  margin-right: 20px;
  }
  ul.contact-info li {
  display: inline-block;
  }

  .score-model-name {
  font-weight: 700;
  }
  .score-model-date {
  font-weight: 700;
  }
  .score-value {
  font-weight: 700;
  font-size: 2.75em;
  color: #ff4d50;
  text-align: right;
  padding-left: 30px;
  min-width: 50%;
  }

  .fields-list-wrapper > div {
  padding: 10px 20px;
  }
  
  .fields-list-wrapper > div.lead-fields {
  margin-right: 10px;
  }
  
  .fields-list-wrapper div.crm-fields {
  margin-left: 10px;
  }

  .lead-detail table {
  border-radius: 4px;
  }
  
  .lead-detail .table > tbody > tr > td {
  padding: 10px 10px;
  }
  
  .lead-detail th {
  background-color: initial;
  color: initial;
  }

  .service-title {
    text-transform: uppercase;
  }

  .lead-data table {
    overflow-x: auto;
  }

</style>



// WEBPACK FOOTER //
// ContactDataModal.vue?3de63c97